import { RoomNotice } from "@/core/api/room.notice.api"
import { Room } from "@/core/api/room.api";

export default {
  createNotice: async ({ dispatch, commit, getters, rootGetters }, data) => {
    let notice = await RoomNotice.createNotice(data);
    commit('ADD_NOTICE', notice);
  },
  setNoticeFix: async ({ dispatch, commit, getters, rootGetters }, noticeInfo) => {
    await RoomNotice.setNoticeFix(noticeInfo);
    commit('SET_NOTICE_FIX', noticeInfo);
  },
  deleteNotice: async ({ dispatch, commit, getters, rootGetters }, notice) => {
    await RoomNotice.deleteNotice({
    noticeId: notice.noticeId,
    });
    commit('DELETE_NOTICE', notice.noticeId);
  },
};
